/**
 * Column keys of the `direct-sale-item` grid read by host-side helpers (bulk item
 * selection and bulk actions, T20-138676). Part of the wire contract with the grid
 * definition — see PREDEFINED_COLUMNS in WorkItemsSegment and the backend definition;
 * a renamed column must be updated here or the helpers silently match nothing
 * (getRowCellValue returns undefined for absent columns).
 */
export const DIRECT_SALE_ITEMS_GRID_COLUMNS = {
  type: 'type',
  articleId: 'articleId',
  warehouseId: 'warehouseId',
  neededAt: 'neededAt',
  unitPrice: 'unitPrice',
  amount: 'amount',
} as const;
